import DataSelectionModel from "./DataSelectionModal";
import { WfsGetFeatureRequest } from "../../types/Wfs/WfsGetFeatureRequest";
import * as yup from "yup";
import Form from "react-bootstrap/Form";
import { useDataSelectionContext } from "./DataSelectionContext";
import { useMemo } from "react";

interface OSCodePointsFormValues {
    outputFormat: string;
  }

const CodePoint = () => {
const layerName = "OS:CodePoints";
const { layers, getLayer, wfsOrder } = useDataSelectionContext();
const layer = useMemo(() => getLayer(layerName), [layers]);
const initialValues = useMemo(
    () =>
      ({
        outputFormat: "gml",
      } as OSCodePointsFormValues),
    [layer],
  );
  const schema = useMemo(
    () =>
      yup.object({
        outputFormat: yup.string().oneOf(["shapefile", "csv", "gml"]).required(),
      }),
    [layer],
  );

const onSubmit = (values: OSCodePointsFormValues) => {
        wfsOrder({
          service: "WFS",
          version: "2.0.0",
          request: "GetFeature",
          resultType: "Results",
          typeNames: layerName,
          outputFormat: values.outputFormat,
        } as WfsGetFeatureRequest);
      };

return (
    <DataSelectionModel
      headerText="Code-Point"
      layer={layer}
      initialValues={initialValues}
      validationSchema={schema}
      onSubmit={onSubmit}> 
      {({ values, handleChange, handleBlur }) => (
        <>
          <Form.Group>
            <Form.Label htmlFor="outputFormat">Format</Form.Label>
            <Form.Select
              id="outputFormat"
              name="outputFormat"
              value={values.outputFormat}
              onChange={handleChange}
              onBlur={handleBlur}>
              <option value="gml">GML 3</option>
              <option value="csv">CSV</option>
              <option value="shapefile">Shapefile</option>
            </Form.Select>
          </Form.Group>
        </>
      )}     
    </DataSelectionModel>
  );
};

export default CodePoint;